import { ApiResponse, AdvancedSearchTypes } from 'app/types-shared';
import { RemoteData } from '../../infrastructure/remote-data';
import { endpoint } from './constants';
import { AdvancedSearchField, FilterDomainsResults } from 'app/components/filters/types';
import { PreDefDateResult } from './types';
import { reportTypes } from 'app/area/favourite/constants';

export const api = {
  loadFilters: async (reportType?: number, reportId?: number): Promise<FilterDomainsResults> => {
    const response = await new RemoteData(reportType && reportId
      ? (reportType === reportTypes.specialReport ? endpoint.filterDomainsSpecialReport(reportId) :
        reportType === reportTypes.dashboard ? endpoint.filterDomainsDashboard(reportId) : endpoint.filterDomains)
      : reportType === reportTypes.bowtieConnectedCasesInfo ? endpoint.filterDomainsBowtie : endpoint.filterDomains)
      .resource<ApiResponse<any>>()
      .all();

    return response.data;
  },

  loadDefaultPredefDate: async (dbFunction: number): Promise<string> => {
    const response = await new RemoteData(endpoint.defaultPredefDate(dbFunction))
      .resource<ApiResponse<PreDefDateResult>>()
      .single();
    return response.data.date;
  },

  loadAdvancedSearchTypes: async (): Promise<AdvancedSearchTypes[]> => {
    const response = await new RemoteData(endpoint.favouriteAdvancedSearchTypes)
      .resource<ApiResponse<AdvancedSearchTypes[]>>()
      .single();
    return response.data;
  },

  loadAdvancedSearchFields: async (ids: number[]): Promise<AdvancedSearchField[]> => {
    const response = await new RemoteData(endpoint.favouriteAdvancedSearchFields)
      .resource<ApiResponse<any>>()
      .filter({ applicationId: ids })
      .single();

    return response.data;
  },

  loadAdvancedSearchFieldsSearch: async (ids: number[], query: string): Promise<AdvancedSearchField[]> => {
    const response = await new RemoteData(endpoint.searchFavouriteAdvancedSearchFields)
      .resource<ApiResponse<any>>()
      .filter({ applicationId: ids, query })
      .single();

    return response.data;
  }

};
